import Styles from './Account.module.scss'
import Avatar from 'common/Avatar/Avatar'
import { getInitials } from 'utils'
import { RoundedPlatformIcon } from 'components/RoundedPlatformIcon/RoundedPlatformIcon'
import { Heading } from 'blaze-ui/Heading/Heading'
import { AccountProps } from 'screens/BrandKit/LinkedAccountsDrawer/Types'
import { Text } from 'blaze-ui/Text/Text'
import { startCase } from 'lodash'
import { PropsWithChildren } from 'react'

export const Account = ({ account, children }: PropsWithChildren<AccountProps>) => {
  const { name, picture, provider, provider_id } = account

  return (
    <>
      <div className={Styles.avatar}>
        <Avatar size={50} label={getInitials(name || startCase(provider))} url={picture} />
        <div className={Styles.icon}>
          <RoundedPlatformIcon platform={provider} size={16} />
        </div>
      </div>
      <div className={Styles.detailsContainer}>
        <div className={Styles.details}>
          <Heading level={5} color="var(--dark-80)" lineClamp={1}>
            {name}
          </Heading>
          {provider_id && (
            <Text variant="metadata" color="var(--dark-40)">
              ID: {provider_id}
            </Text>
          )}
        </div>
        {children}
      </div>
    </>
  )
}
